"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownWithList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _wbmInputs = require("wbm-inputs");
var _List = require("./List");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _SuccessAlert = require("../SuccessAlert");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var DropdownWithList = exports.DropdownWithList = function DropdownWithList(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    display = _useState2[0],
    setDisplay = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inputDisplay = _useState4[0],
    setInputDisplay = _useState4[1];
  var _useState5 = (0, _react.useState)(props.isSkuGroupSearch || props.forceInput ? props.value : ''),
    _useState6 = _slicedToArray(_useState5, 2),
    inputVal = _useState6[0],
    setInputVal = _useState6[1];
  var _useState7 = (0, _react.useState)(props.value),
    _useState8 = _slicedToArray(_useState7, 2),
    previousVal = _useState8[0],
    setPreviousVal = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState9, 2),
    activeVal = _useState10[0],
    setActiveVal = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    qtyUpdatePending = _useState12[0],
    setQtyUpdatePending = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    qtyUpdateError = _useState14[0],
    setQtyUpdateError = _useState14[1];
  var buttonRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var isIE11 = false;
  if (typeof window !== 'undefined') {
    isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  }
  var WrapperComponent = isIE11 ? 'div' : _wbmInputs.Button;
  if (props.storedValue !== undefined && props.storedValue.toString() !== activeVal) {
    setActiveVal(props.storedValue.toString());
  }
  var className = "btn-outline-primary btn-dropdown-list-outline ";
  if (props.className) {
    className += props.className;
  }
  if (!props.isValid) {
    className += ' is-invalid';
  }
  if (props.isSkuGroupSearch || props.forceInput) {
    className += 'btn-qty-input';
  }
  (0, _react.useEffect)(function () {
    if (props.inputRequired && props.inputString !== '' && props.list.filter(function (item) {
      return item.value === props.inputString;
    }).length <= 0) {
      props.list.push({
        value: props.inputString || 0,
        text: props.inputString || ''
      });
    }
  }, [props.inputRequired, props.inputString, props.list]);
  (0, _react.useEffect)(function () {
    setActiveVal(props.value);
  }, [props.value]);
  function _setValue(val, text) {
    setDisplay(false);
    if (props.changeZIndex !== undefined) {
      props.changeZIndex(false);
    }
    props.setValue && props.setValue(val, text);
    if (val === props.inputString) {
      setInputDisplay(true);
    }
  }
  function openMenu(event) {
    event.stopPropagation();
    if (inputDisplay) {
      setDisplay(false);
      if (props.changeZIndex !== undefined) {
        props.changeZIndex(false);
      }
    } else {
      if (props.changeZIndex !== undefined) {
        props.changeZIndex(!display);
      }
      setDisplay(!display);
    }
  }
  function handleChange(e) {
    var val = e.replace(/[^\d]/g, '');
    setActiveVal(val);
    setInputVal(val);
    props.setValue && props.setValue(val, val);
  }
  function handleBlur(e) {
    var val = e.replace(/[^\d]/g, '');
    var arrayCheck = props.list.filter(function (obj) {
      return obj.value === Number(val) || obj.value === val;
    });
    if (val === '' || val === '0') {
      setInputDisplay(false);
      setInputVal('');
      props.setValue && props.setValue(props.list[0].value, props.list[0].text);
    } else if (inputVal === '' && arrayCheck.length > 0) {
      setInputDisplay(false);
      setInputVal('');
      props.setValue && props.setValue(arrayCheck[0].value, arrayCheck[0].text);
    }
    if (val !== '0' && val !== '') {
      if (val != previousVal && props.qtyOnBlur) {
        setQtyUpdatePending(true);
        props.qtyOnBlur(val).subscribe(function (response) {
          setQtyUpdatePending(false);
        }, function (error) {
          setQtyUpdateError(true);
          setQtyUpdatePending(false);
        });
      }
      setPreviousVal(val);
    }
  }
  (0, _react.useEffect)(function () {
    if (inputRef && inputDisplay === true) {
      inputRef.current.focus();
    }
  }, [inputDisplay]);
  (0, _react.useEffect)(function () {
    if (props.isSkuGroupSearch || props.forceInput) {
      setInputVal(props.value);
    }
  }, [props.value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown-menu-overall"
  }, !qtyUpdatePending && /*#__PURE__*/_react["default"].createElement(WrapperComponent, {
    id: "dropdownButton",
    className: className,
    onClick: function onClick(event) {
      return openMenu(event);
    },
    ref: buttonRef
  }, inputDisplay || props.isSkuGroupSearch || props.forceInput ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_wbmInputs.TextBox, {
    inputRef: inputRef,
    id: "dropdown-menu-input-".concat(props.inputIdentifier),
    type: "text",
    className: " dropdown-menu-input",
    maxLength: props.setLength || 4,
    value: inputVal.toString(),
    onChange: handleChange,
    onFocus: function onFocus() {
      return setTimeout(function () {
        var _inputRef$current;
        inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.select();
      }, 20);
    },
    onBlur: handleBlur,
    label: "dropdown-menu-input-".concat(props.inputLabel),
    hiddenLabel: true,
    showPlaceHolder: false,
    inputMode: "numeric",
    autoFocus: inputDisplay
  })) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "dropdown-input-label"
  }, " ", props.label, " "), !inputDisplay && !props.isSkuGroupSearch && !props.forceInput ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "chev-space"
  }, props.isValid && !display ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "material-icons chev animate-arrow",
    "aria-label": "keyboard_arrow_down"
  }, "keyboard_arrow_down") : props.isValid && display ? /*#__PURE__*/_react["default"].createElement("span", {
    id: "dropdownChevron",
    className: "material-icons chev animate-arrow selected",
    "aria-label": "keyboard_arrow_down"
  }, "keyboard_arrow_down") : /*#__PURE__*/_react["default"].createElement(_Close["default"], null)) : null), !props.isValid ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "invalid-text"
  }, props.invalidFeedback) : null, !props.isSkuGroupSearch && !props.forceInput && !qtyUpdatePending && /*#__PURE__*/_react["default"].createElement(_List.List, {
    list: props.list,
    setValue: function setValue(val, text) {
      _setValue(val, text);
      if (props.setStoredValue && props.setStoredLabelValue) {
        props.setStoredValue(val);
        props.setStoredLabelValue(text);
      }
    },
    value: activeVal,
    display: display,
    setDisplay: setDisplay
  }), qtyUpdatePending && /*#__PURE__*/_react["default"].createElement("div", {
    className: "spinner-container ".concat(props.isSkuGroupSearch || props.forceInput ? "btn-qty-input" : "")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "spinner-border spinner-border-md m-1",
    role: "status",
    "aria-hidden": "true"
  })), qtyUpdateError && /*#__PURE__*/_react["default"].createElement(_SuccessAlert.SuccessAlert, {
    timerLengthInMS: 3500,
    danger: true,
    dangerText: "Please try again. If the problem persists, please call 1-888-WB-MASON.",
    dangerAttentionText: "An error has occurred!",
    onClickClose: setQtyUpdateError,
    attentionText: '',
    text: ''
  }));
};
//# sourceMappingURL=DropdownWithList.js.map